import { GotifyMessage } from '../models/GotifyMessage'
import { Notification } from '../models/Notification'
import { SendingStatus } from '../enums/SendingStatus'
import { TransportType } from '../../../common/enums/TransportType'
import { EventType } from '../enums/EventType'

export function adaptGotifyMessage(gotifyMessage: GotifyMessage): Notification {
  return new Notification({
    id: gotifyMessage.id,
    title: gotifyMessage.title,
    message: gotifyMessage.message,
    recipientID: (gotifyMessage.extras?.recipientID as string) ?? '',
    senderID: (gotifyMessage.extras?.senderID as string) ?? '',
    deliveryStatus: SendingStatus.Pending,
    createdAt: new Date(gotifyMessage.date),
    eventType: (gotifyMessage.extras?.eventType as EventType) ?? '',
    transportType: TransportType.App,
  })
}
